import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './App.css';
import AppRouter from './components/AppRouter';
import AnimatedBackground from './components/AnimatedBackground';
import { CartProvider } from './contexts/CartContext';
import { initGA, trackPageView } from './utils/analytics';

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_GA_TRACKING_ID) {
      initGA(process.env.REACT_APP_GA_TRACKING_ID);
      trackPageView(window.location.pathname);
    }
    // Service Worker: solo en producción. En desarrollo lo desregistramos para ver cambios.
    if ('serviceWorker' in navigator) {
      if (process.env.NODE_ENV === 'production') {
        window.addEventListener('load', () => {
          navigator.serviceWorker.register('/sw.js')
            .then((registration) => console.log('Service Worker registrado:', registration.scope))
            .catch((error) => console.log('Error registrando Service Worker:', error));
        });
      } else {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((r) => r.unregister());
        });
      }
    }
  }, []);

  const customBackgroundImages = [
    '/images/HojaCannabis.png',
    '/images/Romero.png',
    '/images/savila.png',
    '/images/miel.png',
    '/images/agua.png',
    '/images/fuego.png',
    '/images/aire.png',
    '/images/montana.png',
  ];

  return (
    <HelmetProvider>
      <div className="App">
        <AnimatedBackground particleCount={25} staticCount={8} customImages={customBackgroundImages} />
        <CartProvider>
          <AppRouter />
        </CartProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
